import { differenceInMonths } from 'date-fns';

export function calculateAgeFromDateOfBirth(dateOfBirth: string | Date): number {
    const birthDate = typeof dateOfBirth === 'string' ? new Date(dateOfBirth) : dateOfBirth;

    return Math.trunc(differenceInMonths(new Date(), birthDate) / 12);
}
